// 模块
export default {
	home: {
		name: "首頁"
	}
};
